var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemConectionsIconStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.6 28",
    style: {
      enableBackground: "new 0 0 35.6 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ADD8E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,13C12.4,13,12.4,13,12.3,13c3.6,0,6.5-2.9,6.5-6.5C18.9,2.9,16,0,12.4,0c0,0,0,0,0,0c0,0,0,0,0,0 C8.7,0,5.8,2.9,5.8,6.5C5.8,10.1,8.8,13,12.3,13z M8.9,3c0.6-0.6,1.2-0.9,1.6-1.1c0.8-0.3,1.5-0.4,1.9-0.4c0,0,0,0,0,0 c2.7,0,4.9,2.2,4.9,4.9c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9C7.4,5.2,7.9,4,8.9,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,15.2c-1.6-0.6-3.2-0.9-4.9-0.9c-5.1,0-10,3.1-12.1,8.1c-0.2,0.5-0.3,1-0.3,1.5C0,26.1,1.8,28,4.1,28 h16.5c0,0,0,0,0,0c1.3,0,2.6-0.7,3.3-1.8c0.8-1.1,0.9-2.6,0.4-3.8C23.1,19.1,20.5,16.5,17.2,15.2z M22.7,25.3 c-0.4,0.7-1.2,1.1-2,1.1H4.1c-0.7,0-1.3-0.3-1.8-0.7s-0.7-1.1-0.7-1.8c0-0.3,0.1-0.6,0.2-0.9c1.7-4.3,5.9-7.1,10.6-7.1 c1.5,0,2.9,0.3,4.3,0.8c2.9,1.2,5.2,3.4,6.3,6.3C23.2,23.7,23.2,24.6,22.7,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,14c3,0,5.4-2.4,5.4-5.4c0-3-2.4-5.4-5.4-5.4c0,0,0,0,0,0c-3,0-5.4,2.4-5.4,5.4S22.6,14,25.5,14z  M25.5,4.9L25.5,4.9c2.1,0,3.8,1.7,3.8,3.8c0,1-0.4,2-1.1,2.7c-0.7,0.7-1.7,1.1-2.7,1.1c-2.1,0-3.8-1.7-3.8-3.8S23.5,4.9,25.5,4.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,21.3c-1.6-4-5.5-6.6-9.8-6.6c0,0,0,0,0,0c0,0,0,0,0,0c-1.3,0-2.6,0.2-3.8,0.7c-0.2,0.1-0.4,0.3-0.5,0.6 c0,0.3,0.1,0.5,0.3,0.7c1.9,1.6,3.3,3.7,4.1,6c0.3,0.8,0.3,1.6,0,2.4c-0.1,0.2,0,0.5,0.1,0.7c0.1,0.2,0.4,0.3,0.6,0.3c0,0,0,0,0,0 h5.8c0,0,0,0,0,0c1.9,0,3.4-1.5,3.4-3.4C35.6,22.2,35.6,21.7,35.4,21.3z M34,22.6c0,1-0.8,1.8-1.8,1.8h-4.8c0.1-0.8,0-1.6-0.3-2.3 c-0.8-2.1-2-4-3.5-5.7c0.3-0.1,0.6-0.1,1-0.2c0.4,0,0.7-0.1,1-0.1c0,0,0,0,0,0c3.1,0,5.7,1.9,6.9,3.2c0,0,0.9,1,1.4,2.3 C34,22.1,34,22.3,34,22.6L34,22.6L34,22.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemConectionsIconStroke);
export default __webpack_public_path__ + "static/media/item_conections_icon_stroke.d361fb1199bbd39fc10f2a892ca46fd8.svg";
export { ForwardRef as ReactComponent };